/**
 * Externe links openen in een nieuw tabblad.
 *
 * Dit staat in JS en niet in de Liquid, omdat de klant links kan zetten in
 * richtext-velden en menu's. Daar komt geen target op, en dat kun je in het
 * thema niet per link afdwingen. Zo geldt de regel overal, ook voor wat er
 * later nog bijkomt.
 */

/** De winkel kan onder meerdere domeinen bereikbaar zijn; die zijn niet extern. */
const ownHosts = new Set(
  [window.location.hostname, ...(document.documentElement.dataset.shopDomains || "").split(",")]
    .map((d) => d.trim())
    .filter(Boolean),
);

function markExternalLinks(root = document) {
  for (const link of root.querySelectorAll('a[href^="http"]')) {
    if (ownHosts.has(link.hostname)) continue;

    link.target = "_blank";

    // Ook op links die al een target hadden. Zonder noopener kan de geopende
    // pagina via window.opener terugwijzen naar deze, en juist die links
    // stonden er al met een kaal target op.
    const rel = new Set((link.rel || "").split(/\s+/).filter(Boolean));
    rel.add("noopener");
    rel.add("noreferrer");
    link.rel = [...rel].join(" ");
  }
}

markExternalLinks();

document.addEventListener("shopify:section:load", (event) => markExternalLinks(event.target));
